import React, { useState, useEffect, useContext } from "react";
import "../../../../assets/CreditAnalyse/css/creditcheck.scss";
import "../../../../assets/CreditAnalyse/css/credit-analysis.scss";
import Logowhite2 from "../../../../assets/CreditAnalyse/img/logo-white.png";
import AnalysisIcon from "../../../../assets/CreditAnalyse/img/analysis-icon.png";
import SearchGif from "../../../../assets/CreditAnalyse/img/searching.gif";
import sslpng from "../../../../assets/CreditAnalyse/img/ssl-png.png";
import { useHistory } from "react-router-dom";
import VisitorParamsContext from "../../../../Contexts/VisitorParams";
import QueryStringContext from "../../../../Contexts/QueryString";
import { usePageLoad } from "../../../../Hooks/usePageLoad";
import { getPageName } from "../../../../Constants/PageNames";

const CreditCheckConfirm_UFC_DC_RF_V1 = () => {

  const history = useHistory();
  const [currentProgress, setCurrentProgress] = useState(0);
  const query = new URLSearchParams(window.location.search);
  const nextPage = query.get("nextPage");
  const splitName = query.get("splitName");
  const uuid = query.get("uuid");
  const { visitorParameters } = useContext(VisitorParamsContext);
  const { queryString } = useContext(QueryStringContext);
  const { savePageLoad, calledOnce } = usePageLoad();

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentProgress(currentProgress + 1);
    }, 80);
    if (currentProgress == 100) {
      history.push("/" + nextPage + "?uuid=" + uuid);
    }
    return () => clearInterval(timer);
  }, [currentProgress]);

  useEffect(() => {
    if (!!uuid && !calledOnce) {
      const data = {
        uuid,
        page_name: getPageName("credit_confirm"),
        status: "visited",
        source: "regular",
      };
      (async () => {
        await savePageLoad(
          visitorParameters.visitor_parameters,
          data,
          "visited_status",
          splitName,
          queryString,
          visitorParameters.data
        );
      })();
    }
  }, [uuid, calledOnce]);

  return (
    <>
      <div className="supagebg creditSection">
        <section className="creditanalysis">
          <header className="credheader">
            <div className="container">
              <div className="row">
                <div className="col-12 text-center">
                  <a href="index.html">
                    <img className="header-logo" src={Logowhite2} height={45} />
                  </a>
                </div>
              </div>
            </div>
          </header>
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-12 offset-lg-3">
                <div className="nobg d-flex align-items-center mt-3">
                  <div className="col-lg-2 col-3 text-center">
                    <img src={AnalysisIcon} height="50" alt="" />
                  </div>
                  <div className="col-lg-10 col-9 bor-left-cred  align-self-center">
                    <h4>Please wait while we complete your credit analysis.</h4>
                  </div>
                </div>
                <div className="col-12 text-center">
                  <div className="progress-container mt-3">
                    <div
                      className="progress-circle"
                      style={{
                        background: `conic-gradient(#1DD9B3 ${
                          (currentProgress / 100) * 360
                        }deg, #1732a2 ${(currentProgress / 100) * 360}deg)`,
                      }}
                      id="progress-circle"
                    >
                      <div className="progress-inner">
                        <div>
                          <span id="progress-value" className="fw-bold">
                            {currentProgress}%
                          </span>
                          <div className="text2">COMPLETED</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-4 drop-in col-12 crediatailsloader text-center">
                <div className="cred-slide1">
                  <img src={SearchGif} height="90" alt="" />
                  <p>Please wait ...</p>
                  <h3>
                    We're reviewing your financial history for hidden commission
                    refunds and will let you know if any additional claim
                    opportunities arise.{" "}
                  </h3>
                  <img src={sslpng} height="50" alt="" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default CreditCheckConfirm_UFC_DC_RF_V1;
